import { stringify } from 'qs';
import request from '../../utils/request';
import func from '../../utils/Func';
import { getSiteIp } from '../../utils/index';

export async function list(params) {
  return request(`/api/tscloud-eq-interact/conference/page?${stringify(params)}`);
}

export async function getAttrList(params) {
  return request(`/api/blade-system/attribute-template-detail/getAttrListByAttrTmplDetailId?${stringify(params)}`);
}

export async function getReplayList(params) {
  // return request(`/api/tscloud-eq-interact/conference/replayList?${stringify(params)}`);
  return request(`/api/blade-mbs/biz-file-detail/replayList?${stringify(params)}`);
}

export async function info(params) {
  return request(`/api/tscloud-eq-interact/conference/detail?${stringify(params)}`);
}

export async function getPlayUrl(params) {
  const payload = { ...params, siteIp: getSiteIp() };
  return request(`/api/blade-mbs/stream/play-url?${stringify(payload)}`);
}

export async function getUserSign(params) {
  return request(`/api/blade-mbs/tencent/im/createDefaultUserSign?${stringify(params)}`);
}

export async function querProfile(params) {
  return request(`/api/tscloud-eq-interact/conference-profile/page?${stringify(params)}`);
}

export async function detail(params) {
  return request(`/api/tscloud-eq-interact/conference/detailInfo?${stringify(params)}`);
}

export async function remove(params) {
  return request(`/api/tscloud-eq-interact/conference/remove`, {
    method: 'POST',
    body: func.toFormData(params),
  });
}

export async function memberPage(params) {
  return request(`/api/tscloud-eq-interact/conferenceconventioner/page?${stringify(params)}`);
}

export async function getConnections(params) {
  return request(`/api/blade-mbs/stream/connection-info?${stringify(params)}`);
}

export async function conferenceStart(params) {
  return request(`/api/tscloud-eq-interact/simplify/conference/control/start`, {
    method: 'POST',
    body: params,
  });
}

export async function conferenceEnd(params) {
  return request(`/api/tscloud-eq-interact/simplify/conference/control/end`, {
    method: 'POST',
    body: params,
  });
}